import React,{useState,useEffect} from 'react'
import './index.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import EditButton from '../../../../components/panelcontrols/paneltablebuttons/editbutton'

const Index = ({List,setSelectedUserID,setShowEdit}) => {
  const [filterList,setfilterList] = useState(List);
  function filterFunction(value){
    if(value === ""){
      setfilterList(List);
    }
    else{
      const filtedList = List.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setfilterList(filtedList);
    }
  }
  useEffect(()=>{
      setfilterList(List);
  },[List])
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input onChange={(e)=>{filterFunction(e.target.value);}}/>
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              <div className='_th' style={{width:"15%"}}>Username</div>
              <div className='_th' style={{width:"10%"}}>First name</div>
              <div className='_th' style={{width:"10%"}}>Last name</div>
              <div className='_th' style={{width:"20%"}}>Email</div>
              <div className='_th' style={{width:"10%"}}>Role</div>
              <div className='_th' style={{width:"15%"}}>Lab</div>
              <div className='_th' style={{width:"20%"}}></div>
            </div>
          </div>
          <div className='_tbody'>
            {
              filterList.map((item,index)=>{
                return(
                  <div className='_tr' key={index}>
                    <div className='_td' style={{width:"15%"}}>{item.username}</div>
                    <div className='_td' style={{width:"10%"}}>{item.firstname}</div>
                    <div className='_td' style={{width:"10%"}}>{item.lastname}</div>
                    <div className='_td' style={{width:"20%"}}>{item.email}</div>
                    <div className='_td' style={{width:"10%"}}>{item.role}</div>
                    <div className='_td' style={{width:"15%"}}>{item.labname}</div>
                    <div className='_td' style={{width:"20%",display:"flex",justifyContent:"flex-end"}}>
                      <EditButton Action={()=>{
                        setSelectedUserID(item.id);
                        setShowEdit(true);
                      }}/>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>      
    </div>
  )
}

export default Index
